import i18next from "i18next";

export enum DocumentTypeEnum {
    CONTRACT = 0,                   // Umowa
    ACCEPTANCE_REPORT = 1,          // PO - Protokół odbioru
    HANDOVER_PROTOCOL = 2,          // PP - Protokół przekazania
    EXTERNAL_RECEPTION = 3,         // PZ - przyjęcie zewnętrzne (zakup)
    DESTRUCTION_PROTOCOL = 4,       // Protokół zniszczenia
    RECIPIENT_RESERVATION = 5,
    INVOICE = 6,                    // Faktura
    INVENTORY = 7,                  // Inwentura
    MM_PLUS = 8, 
    MM_MINUS = 9
}

const documentTypeLabelKeys: { [type: number]: string } = {
    [DocumentTypeEnum.CONTRACT]: "nav.docTypeContract",
    [DocumentTypeEnum.ACCEPTANCE_REPORT]: "nav.docTypeAcceptanceReport",
    [DocumentTypeEnum.HANDOVER_PROTOCOL]: "nav.docTypeHandoverProtocol",
    [DocumentTypeEnum.EXTERNAL_RECEPTION]: "nav.docTypeExternalReception",
    [DocumentTypeEnum.DESTRUCTION_PROTOCOL]: "nav.docTypeDestructionProtocol",
    [DocumentTypeEnum.RECIPIENT_RESERVATION]: "nav.docTypeRecipientReservation",
    [DocumentTypeEnum.INVOICE]: "nav.docTypeInvoice",
    [DocumentTypeEnum.INVENTORY]: "nav.docTypeInventory",
    [DocumentTypeEnum.MM_PLUS]: "nav.docTypeMMplus",
    [DocumentTypeEnum.MM_MINUS]: "nav.docTypeMMminus",
};

export const translateDocumentType = (type: number, name: string, t: (key: string) => string): string =>
    !(i18next.language || "pl").startsWith("pl") && documentTypeLabelKeys[type] !== undefined ? t(documentTypeLabelKeys[type]) : name;
